import { render, staticRenderFns } from "./DefectReportListItem.vue?vue&type=template&id=3bb7ec40&scoped=true&"
import script from "./DefectReportListItem.vue?vue&type=script&lang=js&"
export * from "./DefectReportListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb7ec40",
  null
  
)

export default component.exports